const ethers = require('ethers');
export const isValidEthereumAddress = (address) => {
    return ethers.utils.isAddress(address)
}